
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevTag } from '@ds/components/Tag'
import { mapGetters } from 'vuex'

import { Prices } from '@core/components/prices'

import productThumbTranslations from '../ProductThumb.translations'
import { isLinkValid } from '../helpers'

import translations from './List.translations'

/** @deprecated */
export default {
  components: {
    RevButtonBase,
    RevIllustration,
    RevCard,
    Prices,
    RevTag,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    attributes: {
      type: Array,
      required: true,
    },
    isRecommendation: {
      type: Boolean,
      default: false,
    },
    link: {
      type: Object,
      required: true,
    },
    thumbnail: {
      type: String,
      required: true,
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} price
     * @property {number} price.raw
     * @property {string} price.display
     */
    price: {
      type: Object,
      required: true,
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} originalPrice.raw
     * @property {string} originalPrice.display
     */
    originalPrice: {
      type: Object,
      required: true,
    },
    isOriginalPriceDisplayed: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
      experiment: 'flags/getExperiments',
    }),
    originalPriceDisplay() {
      return this.$t(productThumbTranslations.originalPriceDisplay, {
        price: this.originalPrice.display,
      })
    },
    translations: () => translations,
    productThumbTranslations: () => productThumbTranslations,
    attributesToDisplay() {
      return this.attributes?.map(({ attributes, label }) => ({
        label,
        value: attributes || this.$t(translations.notDefinedAttribute),
      }))
    },
    displayRecoTag() {
      return this.isRecommendation
    },
    originalPriceValue() {
      return this.isOriginalPriceDisplayed ? this.originalPrice : undefined
    },
    shouldDisplayList() {
      return isLinkValid(this.link, this.$navigation)
    },
  },
  methods: {
    // This method is replacing :nth-child(3) than does not exist in Tailwind v2
    isMultipleOfThree: (index) => {
      return (index + 1) % 3 === 0
    },
  },
}
